import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import messages from '../messages';
import { DeliveryOptionHeader } from './delivery-options-header';
import style from './delivery-options-settings.module.less';

export const MagentoInvalidContent = ({ marketplaceName, defaultWarehouseName }) => (
  <div className={style['delivery-options-settings']}>
    <div className={style['explanation-and-key']}>
      <div className={style.title}>
        <FormattedMessage {...messages.checkoutRates} />
      </div>
      <DeliveryOptionHeader defaultWarehouseName={defaultWarehouseName} marketplaceName={marketplaceName} />
    </div>
    <BannerMessageV2
      content={
        <>
          <div className={style['magento-error-title']}>
            <FormattedMessage {...messages.incompatibleMagentoVersionTitleCR} />
          </div>
          <FormattedMessage
            {...messages.incompatibleMagentoVersionBodyCR}
            values={{
              a: (chunks) => (
                <a href='https://marketplace.magento.com/auctane-api.html' rel='noreferrer' target='_blank'>
                  {chunks}
                </a>
              ),
            }}
          />
        </>
      }
      status={BannerStatus.Error}
    />
  </div>
);

MagentoInvalidContent.propTypes = {
  marketplaceName: PropTypes.string,
  defaultWarehouseName: PropTypes.string,
};
